// Single source of truth for the setup wizard's step names: shared between
// this package's pages (which switch on `step`) and each consuming app's own
// useSetupMFATOTP/useSetupMFAWebAuthn hooks (which set `step`).
export const START_REGISTRATION = 'START_REGISTRATION'
export const REGISTER = 'REGISTER'
export const REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE'
